
import React, { Component } from 'react';

export default class Box extends Component {

    CONFIG = {
        head: 'bg-color-dark',
        body: 'bg-color-white'
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="box">
                <div className={"box-header " + (this.props.head_color || this.CONFIG.head)}>{this.props.header}</div>
                <div className={"box-body " + (this.props.body_color || this.CONFIG.body)}>{this.props.children} </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/ui/Box.js